import { render } from "./MTKBottomButton.vue?vue&type=template&id=d51496fc&scoped=true"
import script from "./MTKBottomButton.vue?vue&type=script&lang=js"
export * from "./MTKBottomButton.vue?vue&type=script&lang=js"

import "./MTKBottomButton.vue?vue&type=style&index=0&id=d51496fc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d51496fc"

export default script